import { render, staticRenderFns } from "./Colophon.vue?vue&type=template&id=5caf9c9c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Colophon.vue"
export default component.exports